declare global {
  var lintrk: Function;
}

export const reportSignupToLinkedin = () => {
    if (process.env.NODE_ENV === "production" && lintrk) {
      try {
        lintrk('track', { conversion_id: 14326865 });
      } catch(e) {
        console.error(e);
      }
    }
};

export const reportPurchaseToLinkedin = () => {
  if (process.env.NODE_ENV === "production" && lintrk) {
      try {
        lintrk('track', { conversion_id: 14326873 })
      } catch(e) {
        console.error(e);
      }
  }
};